import * as React from "react";
import { Link } from "react-router-dom";
import { Theme, makeStyles } from "@material-ui/core";
import Paper from "components/paper";
import SkipLink from "components/skip-link";

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        display: "flex",
        justifyContent: "space-between",
        padding: "5px",
    },
    logoImg: {
        width: "220px",
        height: "80px",
        backgroundImage: theme.logoUrl,
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
    },
}));

const Header: React.FC = ({ children }) => {
    const styles = useStyles();
    return (
        <header>
            <Paper className={styles.root}>
                <div>
                    <SkipLink />
                    <h1>
                        <Link to="/">
                            <div aria-label="Site logo, link to site homepage." role="img" className={styles.logoImg} />
                        </Link>
                    </h1>
                </div>
                {children}
            </Paper>
        </header>
    );
};

export default Header;
